import { render, staticRenderFns } from "./FormTwoFactorAuth.vue?vue&type=template&id=1d5a5a41&scoped=true&"
import script from "./FormTwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./FormTwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./FormTwoFactorAuth.vue?vue&type=style&index=0&id=1d5a5a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a5a41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VExpandTransition,VForm,VIcon,VImg,VRow,VSkeletonLoader,VTextField,VTooltip})
